const useColumnsTwo = (setProduct, handleAdd, handleDelete) => {
  const columnsInside = [
    { Header: "ชื่อผู้ขาย", accessor: "customer_name" },
    { Header: "บัตรประจำตัวประชาชน", accessor: "idcard" },
    { Header: "สินค้า", accessor: "product_name" },
    { Header: "รายละเอียดสินค้า", accessor: "detail" },
    { Header: "ตำหนิ", accessor: "blemishes" },
  ];

  return columnsInside;
};

export default useColumnsTwo;
